import { createContext } from 'react';

import type { OrganizationAddRequest } from '@/services/api/types';

export interface RegistrationContextValue {
  /** Whether a registration request is currently in flight. */
  busy: boolean;
  /** Last user-facing error key, or null. */
  error: string | null;
  /** Whether step 2 (organization / company info) was submitted successfully. */
  organizationSucceeded: boolean;
  /** Submits step 2 (company info); resolves true on success. */
  submitOrganization: (data: OrganizationAddRequest) => Promise<boolean>;
  /** Clears the current error message. */
  clearError: () => void;
}

export const RegistrationContext = createContext<RegistrationContextValue | null>(null);
